module.exports = __webpack_public_path__ + "media/images/eit-health-logo-6b45f7297a5a9399348b995898002ee2.png";